module.exports = __webpack_public_path__ + "media/customizations/terramor/logo-6b92e0e6ddbb39c2a74787226da5a52b.png";